import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";
import axios from "axios";
import { getEnv } from "../helpers/EnvHelper";

export const getPathologyList = async (
  pageNumber,
  pageSize,
  sortField,
  sortOrder
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PATHALOGYLIST,
      {
        pageNumber,
        pageSize,
        sortField,
        sortOrder,
      },
      {
        withCredentials: true,
      }
    );

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getLLMAgentList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.LLMAGENTLIST,
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}; export const refreshLLMMappings = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.LLM_REFRESH_MAPPINGS,
      {},
      { withCredentials: true }
    );
    console.log("response of refresh api : ", response);
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};



export const getModalityList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.MODALITYLIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSubModalityList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SUBMODALITYLIST, {
      withCredentials: true,
      data: {
        paginationDto: body.paginationDto,
        listNumber: body.listNumber,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveNewSubModality = async (saveSubModalityDto) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.SAVESUBMODALITY, saveSubModalityDto
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editExistingSubModality = async (editSubModalityDto) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITSUBMODALITY, editSubModalityDto
      // {
      //   data: {
      //     id: editSubModalityDto.id,
      //     serviceName: editSubModalityDto.serviceName,
      //     expirationTime: editSubModalityDto.expirationTime
      //   }
      // }

    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getErrorCodeList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.ERRORCODELIST, {});
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyErrorSearchList = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ERRORSEARCHLIST,
      {
        data: {
          errorListsSearchDto: payload,
        },
      },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyErrorList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ERRORSTUDYLIST,
      {},
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAnnotationList = async (body) => {
  try {
    const response1 = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/annotation/list",
      {
        data: {
          paginationDto: body.paginationDto,
        },
      }
    );
    return response1;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addAnnotationApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/annotation/add  ",
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getViewAnnotationDetail = async (payload) => {
  try {
    const response1 = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/annotation/view",
      { data: { id: payload.id } }
    );
    return response1;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportTemplatesList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTTEMPLATESLIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStylesList = async (refreshFlag = 0) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}jwtServices/api/agentic/styles?refresh=${refreshFlag}`,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getTemplatesListByAgent = async (agentId) => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}jwtServices/api/agentic/template/by-agent`,
      {
        params: { agentId },
        withCredentials: true,
      }
    );
    console.log("Templates by Agent response:", response);
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};


export const getTemplatesListByFirmId = async () => {
  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}jwtServices/api/agentic/template/grouped-by-agent`,
      {
        withCredentials: true,
      }
    );
    console.log("Template GET response:", response);
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const addAgenticTemplate = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      `${API_BASE_URL}jwtServices/api/agentic/template`,
      payload,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const updateAgenticTemplate = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/api/agentic/template/update",
      payload,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const getStyleByAgentId = async (agentId) => {
  if (!agentId) {
    console.error("getStyleByAgentId: A valid agentId must be provided.");
    return Promise.reject({
      response: {
        data: {
          result: 'FAILURE',
          message: 'Agent ID cannot be empty.'
        },
        status: 400
      }
    });
  }

  try {
    const response = await axiosInterceptor.get(
      `${API_BASE_URL}jwtServices/api/agentic/styles/by-agent-id`,
      {
        params: { agentId },
        withCredentials: true,
      }
    );

    console.log("Style by Agent ID response:", response);
    return response;

  } catch (error) {
    console.error("Error fetching style by agent ID:", error);
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};


export const addOrUpdateStyle = async (styleData) => {
  try {
    const endpoint = styleData.id
      ? "jwtServices/api/agentic/styles/update"
      : "jwtServices/api/agentic/styles";

    const response = await axiosInterceptor.post(
      API_BASE_URL + endpoint,
      styleData,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
export const addOrUpdateTemplate = async (payload) => {
  try {
    const endpoint = payload.id
      ? "jwtServices/api/agentic/template/update"
      : "jwtServices/api/agentic/template";

    const response = await axiosInterceptor.post(
      API_BASE_URL + endpoint,
      payload,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const savePersonalTemplate = async (payload) => {
  try {
    // const endpoint = "jwtServices/api/agentic/template/add-personal-template";
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ADD_PERSONAL_TEMPLATE,
      payload,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    }
    return error.response;
  }
};

export const getReportTemplatesListByTab = async (activeTab, body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL +
      SERVICEURL +
      APIs.REPORTTEMPLATESLISTBYTAB +
      `/${activeTab}`,
      {
        withCredentials: true,
        data: {
          paginationDto: body.paginationDto,
          modalityIds: body.modalityIds,
          clientIds: body.clientIds,
          radiologistIds: body.radiologistIds
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.ADDREPORTTEMPLATE,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.EDITREPORTTEMPLATEAPI,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteReportTemplateApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DELETEREPORTTEMPLATE,
      { data: payload },
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getRadiologistList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTRADIOLOGIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHeaderTemplateList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETHEADERTEMPLATE,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getFirmsList = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.REPORTFIRMS, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getClientsList = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.REPORTCLIENTS + "/" + firmId,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const updateDefaultHeaderTemplate = async (reportId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATEDEFAULTHEADERTEMPLATE,
      {
        data: {
          masterStudyReportId: reportId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getViewReportTemplateDetail = async (reportId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.EDITREPORTTEMPLATE, {
      data: {
        reportTemplateId: reportId,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteStyleApi = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/api/agentic/styles/delete",
      { id: payload.id },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteAgenticTemplateApi = async (agentId, templateId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + "jwtServices/api/agentic/template/delete",
      { agentId, agenticReportTemplate: { templateId: templateId } },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const getAINodeDetails = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.AINODELIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteAINodeDetails = async (nodeId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.AINODEDELETE,
      {
        data:
          { nodeId: nodeId }
      },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveAINode = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.AINODESAVE,
      payload,
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const getExternalFirmDetails = async () => {
  const useMock = false; 

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.EXTERNALFIRMLIST,
      {},
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveClientCredentials = async (payload) => {
  const useMock = false; 

  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVECLIENTCREDNTIALS + "/create",
      payload,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateSecret = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVECLIENTCREDNTIALS + "/generate-secret",
      payload,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
export const updateClientStatus= async(payload)=>{
   try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATECLIENTCREDENTIALS + "/updateclientId",
      payload,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
  
}
export const updateSecretStatus= async(payload)=>{
    try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.UPDATECLIENTCREDENTIALS + "/updatesecret",
      payload,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}
export const saveExternalFirm = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.EXTERNALFIRMSAVE,
      payload,
      { withCredentials: true }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const getReturnReasonCategory = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.RETURNREASONCATEGORYLIST, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteReturnReason = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.RETURNREASONDELETE,
      { data: 
        { id: id } },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveReturnReason = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.RETURNREASONSAVE,
      payload, 
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response?.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
};

export const updateReturnReasonPriority = async (id, direction) => {
  try {
    const body = {
      id: id,
      direction: direction,
    }; 
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.RETURNREASONSWAPORDER,
      { data: body },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
/* --- Radiologist Personal Template APIs --- */

export const getPersonalTemplates = async () => {
    try {
        const response = await axiosInterceptor.get(
            `${API_BASE_URL}jwtServices/api/agentic/template/personal`,
            { withCredentials: true }
        );
        return response;
    } catch (error) {
        if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};

export const createPersonalTemplate = async (payload) => {
    try {
        const response = await axiosInterceptor.post(
            `${API_BASE_URL}jwtServices/api/agentic/template/personal`,
            payload,
            { withCredentials: true, headers: { "Content-Type": "application/json" } }
        );
        return response;
    } catch (error) {
        if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};

export const updatePersonalTemplate = async (payload) => {
    try {
        const response = await axiosInterceptor.post(
            `${API_BASE_URL}jwtServices/api/agentic/template/personal/update`,
            payload,
            { withCredentials: true, headers: { "Content-Type": "application/json" } }
        );
        return response;
    } catch (error) {
        if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};

export const deletePersonalTemplate = async (agentId) => {
    try {
        const response = await axiosInterceptor.post(
            `${API_BASE_URL}jwtServices/api/agentic/template/personal/delete`,
            { agentId },
            { withCredentials: true, headers: { "Content-Type": "application/json" } }
        );
        return response;
    } catch (error) {
        if (error.response?.status === 403) window.location.assign(APIs.REDIRECTLOGOUT);
        else return error.response;
    }
};
